import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode, Fragment as _Fragment, resolveComponent as _resolveComponent, createBlock as _createBlock } from "vue"
import _imports_0 from '../../../assets/images/chat/upload.svg'
import _imports_1 from '../../../assets/images/chat/delete.svg'


const _hoisted_1 = {
  id: "Edit_ProfilePic",
  class: "p-3 d-flex flex-column justify-content-between"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("h6", { class: "fw-semibold pb-3" }, "Change your profile picture", -1 /* HOISTED */)
const _hoisted_3 = {
  key: 0,
  class: "avatar"
}
const _hoisted_4 = ["src"]
const _hoisted_5 = { class: "d-flex justify-content-center py-3 gap-4 fs-6 cursor-pointer" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("img", { src: _imports_0 }, null, -1 /* HOISTED */)
const _hoisted_7 = /*#__PURE__*/_createTextVNode("Upload")
const _hoisted_8 = [
  _hoisted_6,
  _hoisted_7
]
const _hoisted_9 = /*#__PURE__*/_createElementVNode("img", { src: _imports_1 }, null, -1 /* HOISTED */)
const _hoisted_10 = /*#__PURE__*/_createTextVNode("Remove")
const _hoisted_11 = [
  _hoisted_9,
  _hoisted_10
]
const _hoisted_12 = { class: "d-flex align-items-center justify-content-center mt-3" }
const _hoisted_13 = /*#__PURE__*/_createElementVNode("h6", { class: "fw-semibold" }, "Crop your image", -1 /* HOISTED */)
const _hoisted_14 = { class: "d-flex justify-content-center gap-4 mt-2" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Cropper = _resolveComponent("Cropper")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (!_ctx.showCropper)
      ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
          _hoisted_2,
          _createElementVNode("div", null, [
            (_ctx.profilePic)
              ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                  _createElementVNode("img", {
                    src: _ctx.profilePic,
                    class: "avatar-img",
                    alt: "Profile"
                  }, null, 8 /* PROPS */, _hoisted_4)
                ]))
              : (_openBlock(), _createElementBlock("div", {
                  key: 1,
                  class: _normalizeClass(`ava-initials ava-xl ava-initials-${_ctx.profileColor} d-flex m-auto`)
                }, _toDisplayString(_ctx.userInitials), 3 /* TEXT, CLASS */)),
            _createElementVNode("div", _hoisted_5, [
              _createElementVNode("span", {
                class: "d-flex align-items-center gap-2",
                onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.openUploader && _ctx.openUploader(...args)))
              }, _hoisted_8),
              _createElementVNode("input", {
                type: "file",
                ref: "fileInput",
                class: "d-none",
                accept: "image/*",
                onChange: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.onFileChange && _ctx.onFileChange(...args)))
              }, null, 544 /* HYDRATE_EVENTS, NEED_PATCH */),
              (_ctx.profilePic)
                ? (_openBlock(), _createElementBlock("span", {
                    key: 0,
                    class: "d-flex align-items-center gap-2",
                    onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.removeProfilePic && _ctx.removeProfilePic(...args)))
                  }, _hoisted_11))
                : _createCommentVNode("v-if", true)
            ])
          ]),
          _createElementVNode("div", _hoisted_12, [
            _createElementVNode("button", {
              type: "button",
              class: "btn btn-light border border-secondary me-2",
              onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.closeDialog()))
            }, " Close "),
            _createElementVNode("button", {
              type: "button",
              class: "btn btn-primary border border-primary",
              onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.saveProfilePic()))
            }, " Save ")
          ])
        ], 64 /* STABLE_FRAGMENT */))
      : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
          _hoisted_13,
          (_ctx.uploadImage)
            ? (_openBlock(), _createBlock(_component_Cropper, {
                key: 0,
                ref: "cropperRef",
                class: "cropper-container",
                src: _ctx.uploadImage,
                "stencil-component": _ctx.CircleStencil,
                "stencil-props": { movable: true, resizable: true },
                "auto-zoom": true,
                "min-zoom": 1
              }, null, 8 /* PROPS */, ["src", "stencil-component"]))
            : _createCommentVNode("v-if", true),
          _createElementVNode("div", _hoisted_14, [
            _createElementVNode("button", {
              type: "button",
              class: "btn btn-light border border-secondary",
              onClick: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => (_ctx.cancelCrop && _ctx.cancelCrop(...args)))
            }, "Cancel"),
            _createElementVNode("button", {
              type: "button",
              class: "btn btn-primary border border-primary",
              onClick: _cache[6] || (_cache[6] = 
//@ts-ignore
(...args) => (_ctx.saveCropped && _ctx.saveCropped(...args)))
            }, " Confirm ")
          ])
        ], 64 /* STABLE_FRAGMENT */))
  ]))
}